export default "__VITE_ASSET__NVtxNloT__"